import React, { FC } from 'react';
import { Card } from '@sainsburys-tech/luna-card'
import classes from './index.module.scss';
import { ButtonGroupPrimary, ButtonGroupWrapper } from '@sainsburys-tech/luna-button';
import { ConfirmModalProps } from '../../CustomTypes/Filters';

const ConfirmModal: FC<ConfirmModalProps> = (props: ConfirmModalProps) => {
    return (
        <div>
            <div className={classes.backdrop} />
            <Card className={classes.modal}>
                <header className={classes.header}>
                    <h4>{props.title}</h4>
                </header>
                <div className={classes.modalBody }>
                    <div className={classes.content}>
                        <h6>{props.message}</h6>
                    </div>
                    <footer >
                        <ButtonGroupWrapper>
                            <ButtonGroupPrimary>
                                <button
                                    type="button"
                                    className="ln-c-button ln-c-button--outlined ln-u-margin-right"
                                    onClick={() => props.dialogHandler("cancel")}
                                >
                                    Cancel

                                </button>

                                <button type="button"
                                    className="ln-c-button ln-c-button--filled ln-u-margin-right"
                                    onClick={() => props.dialogHandler("confirm")}
                                >
                                    Confirm
                                </button>
                            </ButtonGroupPrimary>
                        </ButtonGroupWrapper>
                    </footer>
                </div>
            </Card>
        </div >
    );
};

export default ConfirmModal;
